import "./LibrariesImport";

// SmoothScroll has to be first
import SmoothScroll from "./animations/SmoothScroll";

import ResizeEvents from "./events/ResizeEvents";
import EventListeners from "./events/EventListeners";
import LazyLoadImages from "./events/ImageLoaded";

import MobileCheck from "./utils/MobileCheck";
import DevHelpers from "./utils/DevHelpers";

import CF7Forms from "./components/CF7Forms";
import Buttons from "./components/Buttons";
import Gallery from "./components/Gallery";
import RichText from "./components/RichText";

import AppearOnScroll from "./data-attributes/AppearOnScroll";
import DataLink from "./data-attributes/DataLink";
import MatchHeight from "./data-attributes/MatchHeight";
import Parallax from "./data-attributes/Parallax";
import TextAppear from "./data-attributes/TextAppear";

LazyLoadImages.init();

export default class StarterKit {
	static init() {
		console.log("%cFabriqué à Lyon par mcube️", "background-color:#211450; color:#FF407D;padding:3px 5px;font-family:monospace;", "www.mcube.fr");
		SmoothScroll.init();

		ResizeEvents.init();
		EventListeners.init();

		MobileCheck.init();
		DevHelpers.init();

		CF7Forms.init();

		AppearOnScroll.init();
		DataLink.init();
		MatchHeight.init();
		Parallax.init();
		TextAppear.init();
		Buttons.init();
		RichText.init();
		Gallery.init();
	}
}
